import React, { Component } from 'react';
import parse from 'html-react-parser';

class LocationCampaignName extends Component {
  render() {
    if ( this.props.locationData.campaign_name ) {
      return (
        <>
        <p>Campaign name</p>
        <p>{parse(this.props.locationData.campaign_name)}</p>
        </>
      )
    } else {
      return null;
    }
  }
}

export default LocationCampaignName;